
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class EvaluatorForm extends Form {
	private static _instance = new EvaluatorForm();

	public static getInstance(): EvaluatorForm {
		return EvaluatorForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {get: true, filter: true};
		this.keyFields = ["offeredSubjectId", "evaluatorId"];
	}

	public getName(): string {
		 return 'evaluator';
	}
}


export class EvaluatorFd extends FormData {
	constructor(form: EvaluatorForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface EvaluatorVo extends Vo {
	offeredSubjectId?: number, 
	phoneNumber?: string, 
	isExternal?: boolean, 
	seasonId?: number, 
	name?: string, 
	instituteId?: number, 
	evaluatorId?: number, 
	email?: string, 
	subjectId?: number
}
